<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-no-ref title="" ref="thisModal" v-bind:onsave="doSave" size="modal-xs">
      <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="activateform">
        <div class="card m-0 shadow-0 border-0" id="loginContainer">
          <div class="card-body pt-2">
            <div class="text-center mb-2">
              <i class="icon-reading icon-2x text-slate-300 border-slate-300 border-3 rounded-pill p-3 mb-2 mt-1"></i>
              <h5 class="mb-0">{{$t('activate_title')}}</h5>
              <span class="d-block text-muted">{{$t('activate_your_account')}}</span>
            </div>
            <div class="alert alert-danger alert-dismissible" v-if="errorMessage != ''">
              <button type="button" class="close" @click="errorMessage = ''"><span>×</span></button>
              <span class="font-weight-semibold">Something went wrong!</span> {{errorMessage}}. Please try again later.
            </div>
            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="text" class="form-control" disabled v-bind:placeholder="$t('username')" v-model="user">
              <div class="form-control-feedback">
                <i class="icon-user text-muted"></i>
              </div>
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="text" class="form-control" v-bind:placeholder="$t('full_name')" v-model="full_name" required="">
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="password" class="form-control" v-bind:placeholder="$t('password')" v-model="password" required="">
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="password" id="password_repeat" @input="didEnter" class="form-control" v-bind:placeholder="$t('password_repeat')" v-model="password_repeat">
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
              <div v-show="displayMatchError == true" class="validation-invalid-label">{{$t('passwords_do_not_match')}}</div>
            </div>

            <div class="form-group">
              <button type="submit" class="btn skin primary-button btn-block" @click="activate">{{$t('activate')}}</button>
            </div>

          </div>
        </div>
      </form>

    </modal-no-ref>
    <ticker ref="ticker"></ticker>
  </div>

</template>

<script>

  import ModalNoRef from "../modals/modal-no-ref.vue";
  import ticker from '../common/common-ticker.vue'
  var password = "";
  var password_repeat = "";
  var displayMatchError = false;
  var enteredsomething = false;
  var full_name = "";
  var errorMessage = "";

  export default {
    name: "user-activate",
    components: {
      ModalNoRef,
      ticker
    },
    props: {
      user: {
        type: String,
        default: ""
      }, 
      fullname: {
        type: String,
        default: ""
      },
      url: {
        type: String,
        default: ""
      },
      state: {
        type: String,
        default: "closed"
      },
      siteid: {
        type: Number,
        default: -1
      }
    },
    computed: {

    },
    data() {
      return {
        password,
        password_repeat,
        displayMatchError,
        full_name,
        errorMessage
      };
    },
    methods: {
      didEnter() {
        if (this.isMatch())
          this.displayMatchError = false;
        else
          this.displayMatchError = true;
      },
      isMatch() {
        if (this.password == this.password_repeat)
          return true;
        else
          return false;
      },
      async activate() {
        if (!$('#activateform').valid())
          return false;

        this.$refs.ticker.start("loginContainer");

        var this_context = this;


        var data = {
          username: this.user,
          password: this.password,
          full_name: this.full_name,
          siteId: this.siteid,
          language: this.$i18n.locale,
        };

        this.$http.post('/api/authentication/activate', data)
          .catch(error => {
            this_context.errorMessage = error.response.status + " An error occurred";
            this_context.$refs.ticker.end("loginContainer");
          })
          .then(function (response) {
            this_context.errorMessage = "";
            var response = response.data;

            if (response.ReturnCode == 1) {
              this_context.closeAndInitiateNux(response.RedirectUrl);
              this_context.$refs.ticker.end("loginContainer");
              this_context.close();
            }
            
            else {
              this_context.errorMessage = "Unknown error:" + response.DetailedMessage;
              this_context.$refs.ticker.end("loginContainer");
            }
          });
     
      },
      
      getTranslatedText() {
        return this.$t('validation_field_success')
      },
      open() {
        this.$refs.thisModal.open();
      },
      close() {
        this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      initValidation() {
        var validator = $('#activateform').validate({
          ignore: 'input[type=hidden], .select2-search__field', // ignore hidden fields
          errorClass: 'validation-invalid-label',
          successClass: 'validation-valid-label',
          validClass: 'validation-valid-label',
          highlight: function (element, errorClass) {
            $(element).removeClass(errorClass);
          },
          unhighlight: function (element, errorClass) {
            //$(element).removeClass(errorClass);
            $(element).siblings().forEach(el => {
              if (el.hasClass(errorClass)) {
                el.removeClass(errorClass);
                el.addClass(successClass);
              }
            });
          },

          success: function (label) {
            //label.addClass('validation-valid-label').text(this.getSuccessText); // remove to hide Success message
          },
          showErrors: function (errorMap, errorList) {
            if (this.numberOfInvalids() > 0)
              this.defaultShowErrors();
          },

          // Different components require proper error label placement
          errorPlacement: function (error, element) {

            // Unstyled checkboxes, radios
            if (element.parents().hasClass('form-check')) {
              error.appendTo(element.parents('.form-check').parent());
            }

            // Input with icons and Select2
            else if (element.parents().hasClass('form-group-feedback') || element.hasClass('select2-hidden-accessible')) {
              error.appendTo(element.parent());
            }

            // Input group, styled file input
            else if (element.parent().is('.uniform-uploader, .uniform-select') || element.parents().hasClass('input-group')) {
              error.appendTo(element.parent().parent());
            }

            // Other elements
            else {
              error.insertAfter(element);
            }
          },
          rules: {
            password: {
              minlength: 5,
              required: true,
            }
          },
          messages: {
            password: {
              required: this.$t('enter_your_password'),
              minlength: jQuery.validator.format(this.$t('password_minlength'))
            }
          }
        });
      },
      closeAndInitiateNux(url) {
        this.$root.$emit('display_nux_intro', url);
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {

      this.full_name = this.fullname;
      if (this.state == "open") {
        this.open();
      }
      this.initValidation();
    },
    created() {
      
    },
  };

</script>

<style>
  .validation-valid-label {
    margin: auto;
    margin-bottom: 30px !important;
    padding-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/user-activate.vue